import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFadeTransition,{attrs:{"mode":"out-in"}},[_c(VBtn,{attrs:{"icon":""},on:{"click":_vm.clearCache}},[_c(VIcon,{attrs:{"size":"18"}},[_vm._v(" "+_vm._s(_vm.icons.mdiNuke)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }